/**============================================================
*   [selectFIle]
*   description : ファイル選択処理
============================================================*/
const uploads = document.querySelectorAll('.c-form-upload');

if (uploads) {
  uploads.forEach(target => {
    //選択ファイル名を表示
    const inputButton = target.querySelector('.js-form-upload');
    const textArea = target.querySelector('.text');
    inputButton.addEventListener('change', () => {
      textArea.textContent = inputButton.files[0].name;
    });
    //選択ファイルを削除
    const deleteButton = target.querySelector('.js-form-delete');
    deleteButton.addEventListener('click', () => {
      inputButton.value = '';
      textArea.textContent = '選択してください';
    });
  });
}

